<script setup>
import { computed } from "vue"
import VueloCard from "./VueloCard.vue"

const props = defineProps({
  resultados: Object
})

// =========================
// FORMATEAR PRECIO
// =========================

const formatearPrecioCOP = (valor) => {

  return `COP ${Number(
    String(valor)
      .replace(/\$/g, "")
      .replace(/\s/g, "")
      .replace(/\./g, "")
      .replace(/,/g, "")
  ).toLocaleString("en-US")}`

}

// =========================
// NORMALIZAR
// =========================

const dataNormalizada = computed(() => {

  const vuelos = props.resultados?.vuelos

  if (!vuelos) {

    return {
      tipo: null,
      col: "col-md-4",
      items: [],
      precioGlobal: null
    }

  }

  // =====================================
  // MULTIDESTINO MANUAL
  // =====================================

  if (
    !Array.isArray(vuelos) &&
    Array.isArray(vuelos.resultados) &&
    vuelos.resultados[0]?.tramo
  ) {

    return {

      tipo: "multi",

      col: "col-md-4",

      precioGlobal: formatearPrecioCOP(vuelos.precio),

      items: vuelos.resultados.map(v => ({

        ...v,

        vuelo: v.ida

      }))

    }

  }

  // =====================================
  // DECAMERON
  // =====================================

  if (
    !Array.isArray(vuelos) &&
    Array.isArray(vuelos.resultados) &&
    vuelos.resultados[0]?.destino
  ) {

    return {

      tipo: "decameron",

      col: "col-md-4",

      precioGlobal: null,

      items: vuelos.resultados.map(v => ({

        ...v,

        total: v.total,

        vuelo: v.ida

      }))

    }

  }

  // =====================================
  // VUELO MANUAL SIMPLE
  // =====================================

  if (
    vuelos.ida &&
    vuelos.regreso &&
    (
      vuelos.ida.escalas !== undefined ||
      vuelos.regreso.escalas !== undefined
    )
  ) {

    return {

      tipo: "manual",

      col: "col-md-6",

      precioGlobal: formatearPrecioCOP(vuelos.precio),

      items: [

        {
          tramo: "IDA",
          vuelo: vuelos.ida
        },

        {
          tramo: "REGRESO",
          vuelo: vuelos.regreso
        }

      ]

    }

  }

  // =====================================
  // SIMPLE AUTOMATICO
  // =====================================

  if (vuelos.ida && vuelos.regreso) {

    return {

      tipo: "simple",

      col: "col-md-6",

      precioGlobal: vuelos.precio,

      items: [

        {
          tramo: "IDA",
          vuelo: vuelos.ida
        },

        {
          tramo: "REGRESO",
          vuelo: vuelos.regreso
        }

      ]

    }

  }

  return {

    tipo: null,

    col: "col-md-4",

    items: [],

    precioGlobal: null

  }

})
</script>

<template>

  <div v-if="dataNormalizada.items.length" class="mt-4">

    <!-- CARDS -->
    <div class="row g-3">

      <div
        v-for="(item, index) in dataNormalizada.items"
        :key="index"
        :class="dataNormalizada.col"
      >

        <VueloCard
          :vuelo="item"
          :tipo="dataNormalizada.tipo"
        />

      </div>

    </div>

    <!-- TOTAL -->
    <div v-if="dataNormalizada.precioGlobal" class="mt-4">

      <div class="
          bg-white
          shadow-sm
          rounded-3
          border
          p-4
          d-flex
          flex-wrap
          gap-3
          justify-content-between
          align-items-center
        ">

        <div class="
            bg-success
            text-white
            rounded-circle
            d-flex
            align-items-center
            justify-content-center
          "
          style="
            width: 60px;
            height: 60px;
            font-size: 24px;
          "
        >

          <i class="bi bi-cash-stack"></i>

        </div>

        <div>

          <div class="d-flex justify-content-center">

            <small class="text-muted d-block">
              Precio total vuelos
            </small>

          </div>

          <h3 class="fw-bold text-success mb-0">

            {{ dataNormalizada.precioGlobal }}

          </h3>

        </div>

        <div class="
            bg-success
            text-white
            rounded-circle
            d-flex
            align-items-center
            justify-content-center
          "
          style="
            width: 60px;
            height: 60px;
            font-size: 24px;
          "
        >

          <i class="bi bi-cash-stack"></i>

        </div>

      </div>

    </div>

  </div>

</template>